



























































































































































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers, MTablehelper, confirmationHelper } from '@/mixins';
import {
  BaseResultModel,
  ScriveTemplateSigningPartyConfigurationModel,
  Dictionary,
  Configuration,
  ScriveTemplateSigningPartyModel,
  ScriveTemplateSigningPartyCreateUpdateModel
} from '@/types';
import { TableStateFields } from '@/types/constants/TableConstants';
import { RouteRegEx } from '@/types/enums';
import { ScriveConfigurationService } from '@/services/scrive/ScriveConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';

export default Vue.extend({
  name: 'ScriveEditSigningParty',
  mixins: [FormFieldValidation, RouteHelpers, MTablehelper, confirmationHelper],
  data() {
    return {
      isLoading: true,
      templateSigningParty: {} as ScriveTemplateSigningPartyModel,
      templateSigningPartyConfiguration: {} as ScriveTemplateSigningPartyConfigurationModel,
      fields: [
        {
          description: {
            label: 'Description',
            sortable: true
          }
        },
        {
          fieldName: {
            label: 'Field Name',
            sortable: true
          }
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],
      items: [] as ScriveTemplateSigningPartyModel[],
      submitIsLoading: false,
      hasError: false,
      errorMessage: '',
      tableStateKey: MTablehelper.Constants.TableStoreKeys.ScriveEditSigningParty
    };
  },
  methods: {
    async initialise(this: any) {
      this.resetViewState();
      await this.getSingningPartyAsync();
    },
    resetViewState(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.ScriveSigningPartyFields);
      if (!canKeepState) {
        this.resetMTableState(this.tableStateKey);
      }
    },
    async onSubmit(this: any) {
      this.resetFormValidation();
      try {
        if (this.validateSignerRole()) {
          this.submitIsLoading = true;

          const result: BaseResultModel = await ScriveConfigurationService.updateSigningPartyAsync(
            this.templateSigningParty.id,
            {
              documentTypeId: this.documentTypeId,
              templateId: this.templateId,
              signerRoleId: this.templateSigningParty.signerRoleId,
              description: this.templateSigningParty.description
            } as ScriveTemplateSigningPartyCreateUpdateModel
          );

          if (result.hasNotification && !result.showToast) {
            this.addFormValidationError(result.notification);
            this.submitIsLoading = false;
            return;
          }

          this.submitIsLoading = false;
          SnotifyConfiguration.showSuccess('Signing Party updated successfully.');
        }
      } catch (error) {
        this.$log('Error updating template', error);
      } finally {
        this.submitIsLoading = false;
      }
    },
    async getSingningPartyAsync(this: any) {
      this.isLoading = true;
      this.resetFormValidation();
      try {
        // tslint:disable-next-line:max-line-length
        this.templateSigningPartyConfiguration = await ScriveConfigurationService.getTemplateSigningPartyConfigurationAsync(
          {
            documentTypeId: this.documentTypeId,
            templateSigningPartyId: this.signingPartyId
          }
        );
        this.templateSigningParty = this.templateSigningPartyConfiguration.templateSigningParty;
        this.items = this.templateSigningPartyConfiguration.templateSigningParty.templateSigningPartyFields;
      } catch (error) {
        this.templateSigningParty = {} as ScriveTemplateSigningPartyModel;
        this.$log('Error getting signing party');
      } finally {
        this.isLoading = false;
      }
    },
    validateSignerRole(this: any): boolean {
      this.resetFormValidation();
      if (this.templateSigningParty.signerRoleId == null || this.templateSigningParty.signerRoleId < 1) {
        this.addFormValidationError('Please select a Signer');
        return false;
      }
      return true;
    },
    onCancel(this: any) {
      this.navigateToEditTemplate();
    },
    navigateToEditTemplate(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.id = this.templateId;
      this.$router.push({
        name: Configuration.Scrive.Template.Edit.name,
        params: param
      });
    },
    navigateToEditSigningPartyField(this: any, id: number) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      param.signingPartyId = this.signingPartyId;
      param.id = id;
      this.onTableStateFieldUpdated('selectedPk', id);
      this.$router.push({
        name: Configuration.Scrive.SigningPartyField.Edit.name,
        params: param
      });
    },
    navigateToAddSigningPartyField(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      param.signingPartyId = this.templateSigningParty.id;
      this.$router.push({
        name: Configuration.Scrive.SigningPartyField.Add.name,
        params: param
      });
    },
    async onDeleteSigningPartyFieldAsync(this: any, id: number) {
      const result = await this.hasDeleteConfirmedAsync(
        this.$bvModal,
        'Are you sure you want to delete this signing party field?'
      );
      if (result) {
        this.isLoading = true;
        try {
          await ScriveConfigurationService.deleteSigningPartyFieldAsync(id);
          SnotifyConfiguration.showSuccess('Signing Party Field deleted successfully.');
          await this.getSingningPartyAsync();
        } catch (error) {
          this.$log('Error deleting Signing Party Field');
        } finally {
          this.isLoading = false;
        }
      }
    }
  },
  computed: {
    tableStateFields() {
      return TableStateFields;
    },
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.templateId);
    },
    signingPartyId(): number {
      return Number(this.$route.params.id);
    },
    headerText(this: any) {
      return this.templateSigningParty?.description
        ? `Edit Signing Party (${this.templateSigningParty.description})`
        : 'Edit Signing Party';
    }
  },
  mounted(this: any) {
    this.initialise();
  },
  components: {
    LoadingSpinner,
    MStoreTable,
    MStoreFormSelect
  }
});
